import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiAppNoDataModule } from '../../_ui/ui-app-no-data/ui-app-no-data.module';
import { UiControlWorksheetsComponent } from './ui-control-worksheets.component';
import { UiTooltipModule } from '../../_ui/ui-tooltip/ui-tooltip.module';
import { PipesModule } from '../../app.pipes.module';
import { AppTranslocoModule } from '../../app.transloco.module';
import { UiPaginationModule } from '../../_ui/ui-pagination/ui-pagination.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@NgModule({
  declarations: [UiControlWorksheetsComponent],
  exports: [UiControlWorksheetsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: UiControlWorksheetsComponent,
        children: [],
      },
      {
        path: ':category',
        component: UiControlWorksheetsComponent,
      },
    ]),
    UiAppNoDataModule,
    UiTooltipModule,
    PipesModule,
    AppTranslocoModule,
    UiPaginationModule,
    LazyLoadImageModule,
  ],
})
export class UiControlWorksheetsModule {}
